export default "__VITE_ASSET__Cc_duLsI__"